
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"12","height":"12"}},[_c('path',{attrs:{"d":"M8.146 1.146a.5.5 0 01.708 0l2 2a.5.5 0 010 .708l-6.5 6.5A.5.5 0 014 10.5H2a.5.5 0 01-.5-.5V8a.5.5 0 01.146-.354l5-5 1.5-1.5zM7 3.707l-4.5 4.5V9.5h1.293l4.5-4.5L7 3.707zm2 .586l.793-.793L8.5 2.207 7.707 3 9 4.293z","fill":"#0D0D0D"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#A0AEC0","d":"M0 0h12v12H0z"}})])])
          )
        }
      }
    